var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "password-wrap"
  }, [_c('div', {
    staticClass: "password-content"
  }, [(_vm.eyeState ? 'text' : 'password') === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "input password",
    class: {
      mb: _vm.mb,
      changeb: _vm.password
    },
    attrs: {
      "name": "passwordInput",
      "autocomplete": "off",
      "placeholder": _vm.log ? _vm.$t(_vm.$loginLangPrefix('userSign.pwTip')) : _vm.$t(_vm.$loginLangPrefix('userSign.webLoginPasswordTips')),
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : _vm.password
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.next();
      },
      "input": _vm.passwordInput,
      "blur": _vm.passwordBlur,
      "change": function change($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.password = $$c;
        }
      }
    }
  }) : (_vm.eyeState ? 'text' : 'password') === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "input password",
    class: {
      mb: _vm.mb,
      changeb: _vm.password
    },
    attrs: {
      "name": "passwordInput",
      "autocomplete": "off",
      "placeholder": _vm.log ? _vm.$t(_vm.$loginLangPrefix('userSign.pwTip')) : _vm.$t(_vm.$loginLangPrefix('userSign.webLoginPasswordTips')),
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.next();
      },
      "input": _vm.passwordInput,
      "blur": _vm.passwordBlur,
      "change": function change($event) {
        _vm.password = null;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "input password",
    class: {
      mb: _vm.mb,
      changeb: _vm.password
    },
    attrs: {
      "name": "passwordInput",
      "autocomplete": "off",
      "placeholder": _vm.log ? _vm.$t(_vm.$loginLangPrefix('userSign.pwTip')) : _vm.$t(_vm.$loginLangPrefix('userSign.webLoginPasswordTips')),
      "type": _vm.eyeState ? 'text' : 'password'
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.next();
      },
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.password = $event.target.value;
      }, _vm.passwordInput],
      "blur": _vm.passwordBlur
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.hide,
      expression: "!hide"
    }],
    staticClass: "eye",
    class: {
      mb: _vm.mb,
      open: _vm.eyeState
    },
    on: {
      "click": function click($event) {
        return _vm.changeEye();
      }
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };